import http from "./httpService";

export function getDisciplinasGradoDocente(docente, grado) {
    let apiEndPoint = `/disciplinas/${docente}/${grado}`;

    return http.get(apiEndPoint);
}